<button
  [class]="buttonClass + ' btn background-green color-white no-radius full-width'"
  type="button"
  (click)="openVideoPlayer()"
>
  {{buttonText}}
</button>
